<template>
  <el-dialog
    title="编辑资料"
    :visible.sync="visible"
    :destroy-on-close="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    :before-close="beforeClose"
    @closed="closed"
    @open="open"
    width="50%">
    <div style="width: 370px; margin: 0 auto;">
      <love-element-upload
        :list-type="uploadOption.listType"
        :drag="uploadOption.drag"
        :allow-type="uploadOption.allowType"
        :allow-size="uploadOption.allowSize"
        :disabled="uploadOption.disabled"
        :limit="uploadOption.limit"
        :multiple="uploadOption.multiple"
        :love-path="uploadOption.lovePath"
        :file-list="uploadOption.fileList"
        :accept="uploadOption.accept"
        :show-file-list="uploadOption.showFileList"
        :tips="uploadOption.tips"
        @preview="onPreview"
        @remove="onRemove"
        @success="onSuccess" />
    </div>
    <div slot="footer">
      <el-button size="medium" type="info" @click="closed">取 消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleCreate">保存</axj-button>
    </div>
  </el-dialog>
</template>
<script>
import commonModels from '@/common/models/common-models'
import { fetchAssistantCourseMaterialList, fetchAssistantCourseMaterial, createAssistantCourseMaterial, updateAssistantCourseMaterial, deleteAssistantCourseMaterial, deleteAssistantCourseMaterials } from '@/api/axj-help/axj-help-course.js'
export default {
  name:"loveMaterialAction",
  props: {
    isCreate: {
      type: Boolean,
      default: true
    },
    sourceDirectory: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    courseId:{
      type:Number,
      default:undefined
    }
  },
  data() {
    return {
      visible: false,
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "text",
        drag: true,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 9,
        lovePath:{
          module: "assistant/course/material",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 10,
        accept: '*',
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        showFileList: true,
        fileList: [] // 不区分文件类型
      },
    };
  },
  methods: {
    open() {
      // 若是父组件没有sourceDirectury 则打开dialog时创建 source_directory
      if(!this.sourceDirectory) {
        this.uploadOption.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
        console.log("无", this.uploadOption.lovePath.source_directory)
      } else {
        this.uploadOption.lovePath.source_directory = this.sourceDirectory
        console.log("有", this.uploadOption.lovePath.source_directory)
      }
      this.init()
    },
    init(){
      // courseId
      if(this.courseId){
        fetchAssistantCourseMaterialList({
          where:JSON.stringify({
            course_id:this.courseId
          })
        }).then(res=>{
          console.log(res)
          for(let x=0;x<res.data.lists.length;x++){
            this.uploadOption.fileList.push({
              url:res.data.lists[x].url,
              name:res.data.lists[x].name
            })
          }
        },error=>{
        })
      }
    },
    closed() {
      // 每次关闭后都会清空文件列表
      this.uploadOption.fileList = []
      this.$emit('update:show',false)
    },
    beforeClose(done) {
      this.$confirm('确认关闭，关闭后上传的文件将不会保存？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    createMaterial(val){
      if(this.courseId>0 && val.length>0) {
        val.forEach(async (item)=> {
          let material = {
            course_id: this.courseId,
            user_id: this.info.id,
            user_name: this.info.nickname,
            user_avatar: this.info.avatar,
            name: item.name,
            type: item.type,
            url: item.url.indexOf('http') >= 0 ? item.url.slice(this.resourcePrefix.url.length) : item.url
          }
          await new Promise((resolve, reject) => {
            createAssistantCourseMaterial(material)
              .then(res => {
                resolve(res)
              })
              .catch(err => {
                reject(err)
              })
          })
        })
      }
    },
    handleCreate() {
      // 将数组提交给外边的组件去创建记录
      this.removeMaterial()
      this.createMaterial(this.uploadOption.fileList)
      this.$nextTick(res=>{
        this.$emit("updateSuccess")
      })
    },
    removeMaterial(){
      deleteAssistantCourseMaterials({
        where:JSON.stringify({
          course_id:this.courseId
        })
      }).then(res=>{
      })
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      console.log(fileList)
      this.uploadOption.fileList=fileList
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        // type: response.type,
        type: response.file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
        status: "success"
      }
      // 更新 fileList
      this.uploadOption.fileList[this.uploadOption.fileList.length] = file
    },
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
  watch: {
    show() {
      this.visible = this.show
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/course-main/component/PageMaterialAction/index.vue